<app-nav-menu></app-nav-menu>
<!--<div><button (click)="SweetSuccess(sweet)">success</button></div>-->
<!--<div class="air_heading">
  <span class="air_h1">Airport Manage</span>
</div>-->
<dx-load-panel [(visible)]="isLoadPanelVisible">
</dx-load-panel>
<div>
  <ng-template #sweet let-modal>

    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/newsuccess.gif" />

      <h2 class="textpopupsuccess"> Airline Data Saved!</h2>
      <button class="okButton" (click)="modal.dismiss()">Ok</button>
    </div>


  </ng-template>
</div>

<!--bad-->
<div>
  <ng-template #bad let-modal>

    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/badicon.gif" />

      <h2 class="textpopupbad"> Not Saved!</h2>
      <h5 class="textsubheadpopup"> Please Try Again!</h5>
      <button class="okButton" (click)="modal.dismiss()">Ok</button>

    </div>


  </ng-template>
</div>


<div class="cms_card">

  <div class="row-card">


    <div class="cms_card-heading"></div>

    <div class="addnewbutton">
      <p class="headingpage">Airline List</p>
      <a class="card-icon" (click)="popupCreateModel(popup)">
        <i class="uil uil-file-plus-alt card_custom-icon"></i>
        <span class="card_custom-name">Add New</span>
      </a>
    </div>
  </div>
  <div>
    <ng-template #popup let-modal>

      <div class="modal-header">
        <span class="closepopup" (click)="modal.dismiss()">&times;</span>
        <h2 class="textpopup"> Create Airline</h2>
      </div>
      <div class="modal-body">
        <div style="margin-top:10px">
          <form class="form-line-active popuplabel">
            <div class="form-row ">
              <!--<div class="col-md-4 mb-3 ">
                <label for="validationServer01">ICOA Code</label>
                <input type="text" class="form-control " name="icaoCode" [(ngModel)]="newobj.icaoCode" id="validationServer01" placeholder="Please Enter ICOA CODE" required>

              </div>-->
              <div class="col-md-4 mb-3">
                <label for="validationServer02">Airline Number</label>
                <input type="text" class="form-control " name="airlineNumCode" id="numberinput" [(ngModel)]="airlineMasterCreateObj.airlineNumCode" placeholder="Please Enter Airline Number" required>
                <span class="tooltiptext" id="message1"></span>
                <span class="messageRequiredCreate" id="airlineNumCode1"></span>
              </div>
              <div class="col-md-4 mb-3">
                <label for="validationServer01">Prefix Code</label>
                <input type="text" class="form-control " name="airlinePrefixCode" id="prefixinput" [(ngModel)]="airlineMasterCreateObj.airlinePrefixCode" placeholder="Please Enter Prefix CODE" required>

                <span class="messageRequiredCreate" id="airlinePrefixCode1"></span>
                <!--<input type="text" class="form-control " name="country" [(ngModel)]="newobj.country" id="validationServer01" placeholder="Please Enter Country" required>-->

              </div>
              <div class="col-md-4 mb-3">
                <label for="validationServer01">Combine Code</label>
                <input type="text" class="form-control " name="airlineCombineCode" id="combineinput" [(ngModel)]="airlineMasterCreateObj.airlineCombineCode" placeholder="Please Enter Combine CODE" required>

                <span class="messageRequiredCreate" id="airlineCombineCode1"></span>
                <!--<input type="text" class="form-control " name="country" [(ngModel)]="newobj.country" id="validationServer01" placeholder="Please Enter Country" required>-->

              </div>

            </div>
            <div class="form-row">
              <div class="col-md-4 mb-3">
                <label for="validationServer03">Legal Name</label>
                <input type="text" class="form-control" name="airlineLegalName" id="legalinput" [(ngModel)]="airlineMasterCreateObj.airlineLegalName" placeholder="Please Enter Legal Name" required>
                <span class="messageRequiredCreate" id="airlineLegalName1"></span>
              </div>
             
              <div class="col-md-4 mb-3">
                <div>
                  <label for="validationServer04">Logo</label>
                </div>

                <div>
                  <input type="file" accept=".svg,.png" [(ngModel)]="airlineMasterCreateObj.airlineLogo" (change)="onFileChangedCreate($event,popup)" style="display:none;" id="file" name="file" />
                  <button class="button-iMAGE" role="button" onclick="document.getElementById('file').click();">Upload</button>
                </div>

                <div>

                  <span class="messageRequiredCreate" id="messageLogo1"></span>
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <!--<object data="{{url}}"  class="image_logo"> </object>-->
                <!--<img src="{{ssvgurl}}" class="image_logo" />-->
                <img src="{{ssvgurl}}" id="svg" class="image_logo" />
              </div>

            </div>

            <button class="btn submitButton" (click)="CreateAirline($event,sweet,bad)" type="submit">Create</button>
          </form>
        </div>
        <!--<button type="submit" (click)="SelectedRows()" class="profilesearchbutton">Submit</button>-->


      </div>
      <!--<div id="employeeInfo" *ngIf="grid.selectedRowKeys.length">
        <input [value]="grid.instance.getSelectedRowsData()[0].lastName" />
      </div>-->
    </ng-template>
  </div>

  <div>
    <ng-template #Updatepopup let-modal>

      <div class="modal-header">
        <span class="closepopup" (click)="modal.dismiss()">&times;</span>
        <h2 class="textpopup"> Update Airline</h2>
      </div>
      <div class="modal-body">
        <div style="margin-top:10px">
          <form class="form-line-active popuplabel">
            <div class="form-row mb-3">
              <!--<div class="col-md-4 mb-3 ">
                <label for="validationServer01">ICOA Code</label>
                <input type="text" class="form-control " name="icaoCode" [(ngModel)]="newobj.icaoCode" id="validationServer01" placeholder="Please Enter ICOA CODE" required>

              </div>-->
              <div class="col-md-4 ">
                <label for="validationServer02">Airline Number</label>
                <input type="number" class="form-control " name="airlineID" [(ngModel)]="airlineMasterObj.airlineID"  hidden>
                <input type="text" class="form-control " name="airlineNumCode" id="numberinput" [(ngModel)]="airlineMasterObj.airlineNumCode" placeholder="Please Enter Airline Number" required>
                <span class="tooltiptext" id="message1"></span>
                <span class="messageRequiredCreate" id="airlineNumCode2"></span>
              </div>
              <div class="col-md-4 ">
                <label for="validationServer01">Prefix Code</label>
                <input type="text" class="form-control " name="airlinePrefixCode" id="prefixinput" [(ngModel)]="airlineMasterObj.airlinePrefixCode" placeholder="Please Enter Prefix CODE" required>

                <span class="messageRequiredCreate" id="airlinePrefixCode2"></span>
                <!--<input type="text" class="form-control " name="country" [(ngModel)]="newobj.country" id="validationServer01" placeholder="Please Enter Country" required>-->

              </div>
              <div class="col-md-4 ">
                <label for="validationServer01">Combine Code</label>
                <input type="text" class="form-control " name="airlineCombineCode"  id="combineinput" [(ngModel)]="airlineMasterObj.airlineCombineCode" placeholder="Please Enter Combine CODE" required>

                <span class="messageRequiredCreate" id="airlineCombineCode2"></span>
                <!--<input type="text" class="form-control " name="country" [(ngModel)]="newobj.country" id="validationServer01" placeholder="Please Enter Country" required>-->

              </div>

            </div>
            <div class="form-row">
              <div class="col-md-3">
                <label for="validationServer03">Legal Name</label>
                <input type="text" class="form-control" name="airlineLegalName" id="legalinput" [(ngModel)]="airlineMasterObj.airlineLegalName" placeholder="Please Enter Legals Name" required>
                <span class="messageRequiredCreate" id="airlineLegalName2"></span>
              </div>
              <div class="col-md-3 ">
                <label for="validationServer03">Airline Status</label>
                <select class="form-control" name="airlineStatus" [(ngModel)]="airlineMasterObj.airlineStatus" id="statusinput2">
                  <option class="optionsupdate">Blocked</option>
                  <option class="optionsupdate">Active</option>

                </select>
                <span class="messageRequiredCreate" id="airlineStatus2"></span>
              </div>
              <div class="col-md-3 ">
                <div>
                  <label for="validationServer04">Logo</label>
                </div>

                <div>
                  <input type="file" accept=".svg,.png" [(ngModel)]="airlineMasterObj.airlineLogo" (change)="onFileChanged($event,Updatepopup)" style="display:none;" id="file" name="file" />
                  <button class="button-iMAGE" role="button" onclick="document.getElementById('file').click();">Upload</button>
                </div>

                <div>
                
                  <span class="messageRequiredCreate" id="messageLogo1"></span>
                </div>
              </div>
              <div class="col-md-3 mb-3">
                <!--<object data="{{url}}"  class="image_logo"> </object>-->
                  <!--<canvas id="canvassn" width="250" height="250" hi></canvas>-->
                <img src="{{url}}" id="svg" class="image_logo" />
              </div>

            </div>

            <button class="btn submitButton" (click)="UpdateAirline($event,sweet,bad)" type="submit">Update</button>
          </form>
        </div>
        <!--<button type="submit" (click)="SelectedRows()" class="profilesearchbutton">Submit</button>-->


      </div>
      <!--<div id="employeeInfo" *ngIf="grid.selectedRowKeys.length">
        <input [value]="grid.instance.getSelectedRowsData()[0].lastName" />
      </div>-->
    </ng-template>
  </div>

 




  <div class="row cms_tabel">
    <div id="grids">
      <dx-data-grid id="grid"
                    [dataSource]="airlineMasterinfo"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [showRowLines]="true"
                    (onContentReady)="contentReady()">


        <dxo-selection mode="single"></dxo-selection>
        <dxo-pager [showPageSizeSelector]="true"
                   [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
        <dxo-paging [pageSize]="100"></dxo-paging>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column [visible]="false" dataType="airlineID" dataField="" alignment="center"></dxi-column>
        <dxi-column [visible]="false" dataType="airlineLogoName" dataField="" alignment="center"></dxi-column>

        <!--<dxi-column dataField="icaoCode" caption="ICAO Code" dataType="string" alignment="center"></dxi-column>-->
        <dxi-column dataField="airlineNumCode" caption="Airline Number Code" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="airlinePrefixCode" caption="Prefix Code" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="airlineCombineCode" caption="Combine Code" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="airlineLegalName" caption="Legal Name" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="airlineLogo" [width]="100" cellTemplate="ImageCell" caption="Logo" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="airlineStatus" caption="Status" dataType="string" alignment="center"></dxi-column>




        <dxi-column caption="Action" [allowSorting]="false" alignment="center" cellTemplate="actionCellTemplate"></dxi-column>
        <div *dxTemplate="let data of 'ImageCell'">
          <img src="{{data.data.airlineLogo}}" />
        </div>

        <div *dxTemplate="let data of 'actionCellTemplate'">
          <div class="card_buttons">
            <a class="card_button-edit" (click)="updatepopup(data.data,Updatepopup)">
              <i class="uil uil-edit card_button-icon"></i>
            </a>
            <a class="cardBlock" (click)="DeleteAirline(data.data.airlineID,sweet,bad)">
              <i class="">

                <img class="imageBlock" src="assets/img/remove.png" />
              </i>
            </a>
          </div>
          <!--<a class="profilesearchbutton" style="margin-left:10px" (click)="Select_Profiledata(data.data)"><i class="fa fa-solid fa-check-square"></i> Select</a>-->
        </div>
      </dx-data-grid>



    </div>

  </div>
</div>
